import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {

  private jsonUrl = 'assets/timezones.json';

  constructor(private http: HttpClient) { }

  getTimezones(): Observable<string[]> {
    return this.http.get<string[]>(this.jsonUrl);
  }

  getCurrentTimezone():string{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

 
}
